import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { usePWAContext } from "../pwa/PWAProvider";
import {
  MdDashboard,
  MdDevices,
  MdNotifications,
  MdBarChart,
  MdLogout,
  MdWifi,
  MdMonitor,
  MdHub,
  MdVerified,
  MdPeople, 
  MdAutoGraph,
  MdSchedule, 
  MdSecurity,
  MdPhoneAndroid,
  MdCircle,
} from "react-icons/md";

const Sidebar = () => {
  const { user, logout } = useAuth();
  const { isOnline } = usePWAContext();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const navLinks = [
    { to: "/dashboard", label: "Dashboard", icon: <MdDashboard size={20} /> },
    { to: "/devices", label: "Devices", icon: <MdDevices size={20} /> },
    { to: "/monitoring", label: "Monitoring", icon: <MdMonitor size={20} /> },
    { to: "/topology", label: "Topology", icon: <MdHub size={20} /> },
    { to: "/alerts", label: "Alerts", icon: <MdNotifications size={20} /> },
    { to: "/anomalies", label: "Anomalies", icon: <MdAutoGraph size={20} /> },
    { to: "/sla", label: "SLA", icon: <MdVerified size={20} /> },
    { to: "/reports", label: "Reports", icon: <MdBarChart size={20} /> },
    { to: "/scheduled-reports", label: "Scheduled", icon: <MdSchedule size={20} /> },
    { to: "/users", label: "Users", icon: <MdPeople size={20} />, adminOnly: true },
    { to: "/audit", label: "Audit Logs", icon: <MdSecurity size={20} />, adminOnly: true },
    { to: "/pwa", label: "PWA Settings", icon: <MdPhoneAndroid size={20} /> },
  ];

  return (
    <div className="h-screen w-64 bg-blue-900 text-white flex flex-col fixed left-0 top-0">
      {/* Logo - fixed at top */}
      <div className="flex-shrink-0 p-6 border-b border-blue-700">
        <div className="flex items-center gap-2">
          <MdWifi size={28} className="text-blue-300" />
          <h1 className="text-xl font-bold">SarifiMesh</h1>
        </div>
        <p className="text-xs text-blue-300 mt-1">Network Monitor</p>
      </div>

      {/* User Info - fixed */}
      <div className="flex-shrink-0 p-4 border-b border-blue-700">
        <p className="text-sm font-medium">{user?.username || "User"}</p>
        <p className="text-xs text-blue-300 mt-1">
          {user?.role === "NETWORK_ADMINISTRATOR"
            ? "Network Administrator"
            : "ICT Support Staff"}
        </p>
      </div>

      {/* Navigation - SCROLLABLE AREA */}
      <div className="flex-1 min-h-0 overflow-y-auto">
        <nav className="p-4 space-y-1">
          {navLinks
            .filter((link) => !link.adminOnly || user?.role === "NETWORK_ADMINISTRATOR")
            .map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-2 rounded-lg text-sm transition ${
                    isActive 
                      ? "bg-blue-700 text-white" 
                      : "text-blue-200 hover:bg-blue-700 hover:text-white"
                  }`
                }
              >
                {link.icon}
                {link.label}
              </NavLink>
            ))}
        </nav>
      </div>

      {/* Status and Logout - fixed at bottom */}
      <div className="flex-shrink-0">
        {/* Online Status */}
        <div className="px-4 py-2 flex items-center gap-2 text-xs">
          <MdCircle
            size={10}
            className={isOnline ? "text-green-400" : "text-red-400"}
          />
          <span className={isOnline ? "text-green-300" : "text-red-300"}>
            {isOnline ? "Online" : "Offline"}
          </span>
        </div>

        {/* Logout */}
        <div className="p-4 border-t border-blue-700">
          <button
            onClick={handleLogout}
            className="flex items-center gap-3 px-4 py-2 rounded-lg text-sm text-blue-200 hover:bg-blue-700 hover:text-white w-full transition"
          >
            <MdLogout size={20} />
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;